import { render } from "./ConfigurationInfo.vue?vue&type=template&id=485774ea&scoped=true"
import script from "./ConfigurationInfo.vue?vue&type=script&lang=js"
export * from "./ConfigurationInfo.vue?vue&type=script&lang=js"

import "./ConfigurationInfo.vue?vue&type=style&index=0&id=485774ea&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-485774ea"]])

export default __exports__
import QTab from 'quasar/src/components/tabs/QTab.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTab});
